import { GTMEvent } from '../GTM'

export const pushPromotionClick = (data: Record<string, unknown>): GTMEvent => {
    const { items } = data
    if (!Array.isArray(items)) {
        console.info('Invalid GTM promotion click data')
        return { event: '' }
    }

    return {
        event: 'promotionClick',
        ecommerce: {
            promoClick: {
                promotions: [...items]
            }
        },
        _clear: true
    }
}
